export class PublicTransportAuthorityCodes {
  public static readonly Vasttrafik = '014';
  public static readonly Oresundstag = '030';
  public static readonly Vy = '075';
  public static readonly Sj = '074';
}
